export default "__VITE_ASSET__D6aACyf9__"